import { createSelector } from 'reselect'

export const getToasts = (state, props) => {
  return state.kanbo.toasts.toasts
}

export const getToastsById = (state, props) => {
  return state.kanbo.toasts.toastsById
}

export const toastsSelector = createSelector(
  [getToasts, getToastsById],
  (toasts, toastsById) => {
    return toasts.map(id => toastsById[id])
  }
)

export default createSelector(
  [
    toastsSelector
  ],
  (
    toasts
  ) => ({
    toasts
  })
)
